// A bar standing on the baseline of a `width` × `total` viewBox, its top corners rounded (4, less on a short bar).
export const barPath = (height, width, total) => {
  if (height <= 0) return "";
  const r = Math.min(4, height, width / 2);
  const y = total - height;
  return `M0 ${total}V${y + r}Q0 ${y} ${r} ${y}H${width - r}Q${width} ${y} ${width} ${y + r}V${total}Z`;
};
